import {fetcher} from "../services/http.service";
import {GetListResponse} from "./apiTypes";
import {useEffect, useState} from "react";
import useSWRInfinite, {SWRInfiniteConfiguration} from "swr/infinite";
import {useSelector} from "react-redux";
import {objToQueryString} from "../common/fns";
import {RootState} from "../reducers/reducer";

export const useDataAll = <T, P = any>(url: string | null, params?: P, pageSize?: number, options?: SWRInfiniteConfiguration) => {
  const {authenticated} = useSelector((state: RootState) => state.auth);
  const [listData, setListData] = useState<T[]>([]);
  const getKey = (pageIndex: number, previousPageData: GetListResponse<T>) => {
    console.log("useDataAll ", url, authenticated, pageIndex, params);
    if (authenticated && pageIndex === 0) {
      const paramString = objToQueryString(params, true);
      return (url + `?page_size=${pageSize || 1000}&${paramString}`);
    }
    if (previousPageData && previousPageData.next) return previousPageData.next;
    return null; // reached the end
  };
  
  const {data, error, setSize, isValidating, mutate} = useSWRInfinite<GetListResponse<T>>(getKey, fetcher, options
    ? options
    : {
      initialSize: 1, revalidateOnFocus: false, revalidateIfStale: false, revalidateFirstPage: false,
    });
  
  useEffect(() => {
    if (data && data?.length > 0) {
      const lastRes = data[data?.length - 1];
      console.log("useDataAll ", url, data, lastRes);
      if (lastRes && lastRes.current_page * lastRes.items_per_page < lastRes.count) {
        setSize((size) => size + 1);
      }
      else {
        let listData: T[] = [];
        data.forEach((item) => {
          if (item?.results) {
            listData = listData.concat(item.results);
          }
        });
        setListData(listData);
      }
    }
  }, [data, setSize, url]);
  console.log("useDataAll", url, listData);
  
  return {
    listData, error, isLoading: isValidating, mutate
  };
};
